/**
 * Display the search result item
 * @param {} $filter 
 * @returns {} 
 */
export default function ($filter, $sce, $rootScope) {


    var searchResultTemplate = `
           <h5> {{ ::result.fullDescription }} <span class="badge" title="{{ ::result.career }}" ng-bind="::result.career.charAt(0)"></span></h5>
           <p ng-if="result.termFullDescription" ng-bind="::result.termFullDescription"></p>
           <p ng-if="result.formalName && result.coordUrl.length > 0">Coordinated by <a ng-href="{{ ::result.coordUrl }}" href="" target="_blank" ng-bind="::result.formalName"></a></p>
           <p ng-if="result.formalName && result.coordUrl === 0">Coordinated by {{ ::result.formalName }}</p>
           <div class="notice">
               <p ng-if="result.offering === 5">This course is only available online.</p>
               <p ng-if="result.offering !== 5">Remember that your courses may have various components such as lectures, tutorials or workshops which you will need to select/enrol into.</p>
               <p ng-if="noteText" ng-bind="::noteText"></p>
               <p  ng-if="result.messageLong" ng-bind="::result.messageLong | sentenceCase"</p>
           </div>
           <table ng-hide="result.offering === 5" ng-class="{\'show-all\' : godMode || showAll }">
               <thead>
                   <tr>
                       <th ng-click="sortByColumn(\'classSection\')" title="Order by: Class">Class <i class="fal fa-sort"></i></th>
                       <th ng-click="sortByColumn(\'meetingDayNo\')" title="Order by: Day">Day <i class="fal fa-sort"></i></th>
                       <th ng-click="sortByColumn(\'location\')" title="Order by: Campus">Campus <i class="fal fa-sort"></i></th>
                       <th>Room</th>
                       <th ng-click="sortByColumn(\'meetingStartTime\')" title="Order by: Time">Time <i class="fal fa-sort"></i></th>
                       <th>Dates</th>
                       <th></th>
                   </tr>
               </thead>
               <tbody>
                  <tr search-result-row result="x" course="result" ng-repeat="x in result.classes | filter:{hiddenByFilter:false} track by $index"></tr>
                  <tr class="no-results-row" ng-if="!showAll && result.allClassesClosed">
                       <td colspan="7">
                          <div class="alert alert-warning footnote" ng-bind-html="allClassesClosedMessage"></div>
                      </td>
                   </tr>
                   <tr class="all-hidden-row" ng-if="result.allClassesHidden && !result.allClassesClosed">
                      <td colspan="7">
                           <div class="alert alert-warning footnote">
                               <p>All classes for this course are hidden by filters.</p>
                           </div>
                      </td>
                   </tr>
              </tbody>
           </table>`;


    return {
        scope: {
            result: '='
        },
        restrict: 'E',
        replace: false,
        template: searchResultTemplate,
        link: function (scope) {

            scope.reverseSort = false;
            var currentSort;            

            scope.sortByColumn = function (col) {
                scope.reverseSort = col !== currentSort ? false : !scope.reverseSort;

                var sortBy = ['classSection', scope.reverseSort ? '-hiddenTitle' : '+hiddenTitle', scope.reverseSort ? '-meetingStartDate' : '+meetingStartDate'];
                var hasHiddenTitles = scope.result.classes.some(x => !x.hiddenByFilter && x.hiddenTitle);

                scope.result.classes = $filter('orderBy')
                    (scope.result.classes, hasHiddenTitles ? sortBy : [col, 'classSection'], scope.reverseSort);

                currentSort = col;
            }

            scope.allClassesClosedMessage = $sce.trustAsHtml($rootScope.allClassesClosedMessage);
            scope.showAll = $rootScope.showAll;

            if (scope.result.classes) {
                scope.noteText =
                    scope.result.classes[0].noteSeq > 0 && scope.result.classes[0].noteText.indexOf(' ') !== -1
                        ? scope.result.classes[0].noteText
                        : undefined;
            }
        }
    };
};